import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex } from '@magnetic/flex';
import { useTranslation } from 'react-i18next';
const Container = styled(Flex) `
  display: flex;
  align-items: center;
  width: 8.6vw;
  background: linear-gradient(90deg, #24c6dc 0%, #514a9d 92%);
  height: 5.8vh;
  margin-top: 1.32vw;
  padding: 1vw;
  position: absolute;
  right: 0vw;
  z-index: 9999999999;
  border-radius: 0.8vw;
  background: linear-gradient(90deg, #24c6dc 0%, #514a9d 92%);
  box-shadow: 0px 5.01px 18.16px 0px rgba(255, 255, 255, 0.6) inset;
  box-shadow: 0px 15.31px 11.83px 0px rgba(0, 0, 0, 0.0944);
  box-shadow: 0px 41.2px 42.99px 0px rgba(0, 0, 0, 0.1167);
  box-shadow: 0px 100px 163px 0px rgba(0, 0, 0, 0.19);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;
const Icon = styled.img `
  width: 4vw;
`;
const Text = styled.div `
  font-size: 1vw;
  font-family: 'Sora';
`;
const Step = styled(Flex) `
  margin-top: 1vw;
  width: 104%;
`;
const StepsContainer = styled.div `
  padding: 1vw;
  margin-top: 0.6vw;
  z-index: 9999999999;
  background: linear-gradient(134.57deg, #212428 0%, #1d2024 99.26%);
  opacity: 0.9;
`;
const Button = styled.div `
  background: black;
  padding: 0.4vw 1vw;
  border-radius: 0.2vw;
`;
const LegacyHowToUseThis = () => {
    const { t } = useTranslation();
    const [showSteps, setShowSteps] = useState(false);
    return (_jsxs(Container, Object.assign({ direction: "vertical" }, { children: [_jsxs(Flex, Object.assign({ id: "how_to_use_this_button", justify: "space-around", onClick: () => setShowSteps(true) }, { children: [_jsxs(Flex, Object.assign({ direction: "vertical", style: { width: '6vw' }, justify: "center" }, { children: [_jsxs(Text, { children: [t('floor.how-do-i'), " "] }), _jsx(Text, { children: t('floor.use-this') })] })), _jsx(Icon, { src: require('../../../../../assets/images/how-do-i-use-this.svg'), alt: "How to use this" })] })), showSteps && (_jsxs(StepsContainer, { children: [_jsxs(Step, Object.assign({ justify: "space-between" }, { children: [_jsx("img", { style: { width: '2vw', marginRight: '1vw' }, src: require('../../../../../assets/images/pan_n_rotate.png') }), _jsx(Text, Object.assign({ style: { fontSize: '0.52vw' } }, { children: t('floor.message-pan-rotate-zoom') }))] })), _jsxs(Step, Object.assign({ justify: "space-between" }, { children: [_jsx("img", { style: { width: '2vw', marginRight: '1vw' }, src: require('../../../../../assets/images/search.png') }), _jsx(Text, Object.assign({ style: { fontSize: '0.52vw' } }, { children: t('floor.message-use-room-finder') }))] })), _jsxs(Step, Object.assign({ justify: "space-between" }, { children: [_jsx("img", { style: { width: '2vw', marginRight: '1vw' }, src: require('../../../../../assets/images/tap_on_meeting.png') }), _jsx(Text, Object.assign({ style: { fontSize: '0.52vw' } }, { children: t('floor.message-tap-on-meeting-room') }))] })), _jsx(Step, Object.assign({ justify: "center" }, { children: _jsx(Button, Object.assign({ onClick: () => {
                                setShowSteps(false);
                            } }, { children: _jsx(Text, Object.assign({ style: { fontSize: '0.72vw' } }, { children: t('floor.message-ok-got-it') })) })) }))] }))] })));
};
export default LegacyHowToUseThis;
